import { useQuery } from "@tanstack/react-query"

import { GetEcobalyseFieldsResponseDto } from "@tfg/types/schemas/modules/lifeCycleAnalysis/dtos/get-ecobalyse-fields.response.dto"

import { httpClient } from "~/backend/axios"

export const useGetEcobalyseFieldsQuery = () =>
  useQuery(["ecobalyseFields"], async () => {
    const res = await httpClient.get<GetEcobalyseFieldsResponseDto>(
      `/admin/lca/get-ecobalyse-fields`
    )
    return res.data
  })
